function bcEvent(){
  // Get all the child menu links
  const childLinks = document.querySelectorAll('[data-breadcrumb]');
  
  // Loop through the child links and add a click event listener
  childLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      
      sessionStorage.setItem('b-crumb', event.target.getAttribute("data-breadcrumb"));
  
    });
  });
}
bcEvent()
